import React, { Fragment } from 'react'
import styled from 'styled-components'
import Media from 'react-media'

import Logo from 'src/components/Logo.js'
import { GRAY } from 'src/styles/colors.js'
import { Row } from 'src/styles/elements.js'

const TopBarWrapper = styled.header`
  margin-bottom: 40px;
  padding: 16px 0;
  color: ${GRAY};
  font-size: 12px;
  line-height: 24px;
`

const Title = styled.span`
  display: inline-block;
  margin-right: 24px;
  font-weight: bold;

  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
    text-align: center;
  }
`

const InlineLogo = styled(Logo)`
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 8px;
  vertical-align: middle;
`

const Link = styled.a`
  display: inline-block;
  margin: 0 4px;
  padding: 0 8px;
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

const Separator = styled.span`
  display: inline-block;
  width: 2px;
  height: 2px;
  vertical-align: middle;
  margin: 0 8px;
  border-radius: 2px;
  background: ${GRAY};
`

/**
 * Top Bar
 */
const TopBar = () => (
  <TopBarWrapper>
    <Row>
      <Title>
        <InlineLogo color={GRAY} />
        Tillsammansskapet
      </Title>

      <Media query="(min-width: 768px)">
        {matches =>
          matches && (
            <Fragment>
              <Link href="http://tillsammansskapet.se" target="_blank">
                tillsammansskapet.se
              </Link>
              <Link
                href="http://tillsammansskapet.se/engagera-dig-mot-rasism/"
                target="_blank"
              >
                Engagera dig
              </Link>
              <Link href="http://tillsammansskapet.se/blogg/" target="_blank">
                Blogg
              </Link>

              <Separator />

              <Link
                href="https://www.facebook.com/Tillsammansskapet/"
                target="_blank"
              >
                Tillsammansskapet på Facebook
              </Link>
            </Fragment>
          )
        }
      </Media>
    </Row>
  </TopBarWrapper>
)

export default TopBar
